module.exports = __webpack_public_path__ + "static/background-b73ec9a19151cb4ae958d8341f4886e1.jpg";